import React from "react";
import { Row, Col, Alert, Container } from "reactstrap";
import { Feedback } from "../../Models/Feedback";
import { Modal, ModalHeader, ModalBody } from "../../../Layout";
import EditFeatureRequestForm from "../FeedbackEdit/EditFeatureRequestForm";
import { FeedbackCategory } from "../../Constants/feedbackEnums";
import EditBugReportForm from "../FeedbackEdit/EditBugReportForm";
import EditResourceRequestForm from "../FeedbackEdit/EditResourceRequestForm";
import { FeatureRequest, BugReport, ResourceRequest } from "../..";

type Props = {
  feedback: Feedback;
  category: FeedbackCategory;
  isOpen: boolean;
  onToggle: () => void;
  onSave: (feedback: Feedback) => void;
};

class EditFeedbackModal extends React.Component<Props> {
  getFormProps = () => {
    return {
      feedback: this.props.feedback,
      canSubmit: true,
      onSubmit: this.props.onSave,
      onDiscard: this.props.onToggle
    };
  };

  getEditForm = () => {
    switch (this.props.category) {
      case FeedbackCategory.FeatureRequest:
        return (
          <EditFeatureRequestForm
            hideTitle
            hidePriorityDropdown
            hideCanShowCommentsDropdown
            {...this.getFormProps()}
          />
        );
      case FeedbackCategory.BugReport:
        return (
          <EditBugReportForm
            hideTitle
            hidePriorityDropdown
            hideCanShowCommentsDropdown
            {...this.getFormProps()}
          />
        );
      case FeedbackCategory.ResourceRequest:
        return (
          <EditResourceRequestForm
            hideTitle
            hidePriorityDropdown
            hideCanShowCommentsDropdown
            {...this.getFormProps()}
          />
        );
      default:
        throw new Error(`Invalid feedback category ${this.props.feedback.category}`);
    }
  };

  getViewPage = () => {
    switch (this.props.feedback.category) {
      case FeedbackCategory.FeatureRequest:
        return (
          <EditFeatureRequestForm
            readonly
            hideTitle
            hideImages
            hideFiles
            hidePriorityDropdown
            hideCanShowCommentsDropdown
            feedback={this.props.feedback as FeatureRequest}
          />
        );
      case FeedbackCategory.BugReport:
        return (
          <EditBugReportForm
            readonly
            hideTitle
            hideImages
            hideFiles
            hidePriorityDropdown
            hideCanShowCommentsDropdown
            feedback={this.props.feedback as BugReport}
          />
        );
      case FeedbackCategory.ResourceRequest:
        return (
          <EditResourceRequestForm
            readonly
            hideTitle
            hideImages
            hideFiles
            hidePriorityDropdown
            hideCanShowCommentsDropdown
            feedback={this.props.feedback as ResourceRequest}
          />
        );
      default:
        throw new Error(`Invalid feedback category ${this.props.feedback.category}`);
    }
  };

  render() {
    return (
      <Modal width="90%" height="90%" isOpen={this.props.isOpen} onToggle={this.props.onToggle}>
        <ModalHeader toggle={this.props.onToggle}>Edit Feedback</ModalHeader>
        <ModalBody>
          <Container fluid>
            <Row>
              <Col xs="12">
                <Alert color="danger" style={{ width: "100%" }}>
                  <small>
                    <span style={{ fontWeight: "bold" }}>Warning:</span> Moving a feedback to a
                    different category will reset its state to the start state of that
                    category&apos;s workflow and you will be required to enter new values for that
                    category&apos;s fields.
                  </small>
                </Alert>
              </Col>
            </Row>
            <Row>
              <Col xs="6">
                <h5>New Feedback Details</h5>
              </Col>
              <Col xs="6">
                <h5 style={{ paddingLeft: ".85rem" }}>Old Feedback Details</h5>
              </Col>
            </Row>
            <hr />
          </Container>

          <Row>
            <Col xs="6">{this.getEditForm()}</Col>
            <Col xs="6">{this.getViewPage()}</Col>
          </Row>
        </ModalBody>
      </Modal>
    );
  }
}

export default EditFeedbackModal;
